<template>
  <!-- レポート作成 -->
  <div id="TotalInspectionsSummary">
    <div id="container">
      <div class="labelTitle lable">検査/解析件数サマリー</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>種別</th>
            <td>
              <select v-model="searchConditions.kind">
                <option></option>
                <option value="1">フルPSG検査</option>
                <option value="2">簡易検査</option>
                <option value="3">睡眠検査機器配送ｻｰﾋﾞｽ</option>
                <option v-for="kenshin in kenshinKindList" :value="kenshin.value" :key="kenshin.value">
                  {{ getKenshinKindName(kenshin) }}
                </option>
                <option value="4">ホルター心電図配送ｻｰﾋﾞｽ</option>
              </select>
            </td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client"/></td>
            <th>医療機関</th>
            <td><input type="text" expanded v-model="searchConditions.hospital"/></td>
          </tr>
          <tr>
            <th>ブロック</th>
            <td><select v-model="searchConditions.block">
                <option value=""></option>
                <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
            </select></td>
            <th>支店</th>
            <td><select v-model="searchConditions.branchOfficeCode">
                <option value=""></option>
                <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
            </select></td>
            <th>営業担当者<br>コード</th>
            <td><input type="text" v-model="searchConditions.salesStaffCode"/></td>
            <th>営業担当者</th>
            <td><input type="text" v-model="searchConditions.salesStaff"/></td>
          </tr>
          <tr>
            <th>解析方法</th>
            <td colspan="3">
              <select v-model="searchConditions.analysisMethod">
                <option v-for="method in analysisMethodList.concat(holterAnalysisMethodList)" :value="method.value" :key="method.value">
                  {{ method.label1 }}
                </option>
              </select>
            </td>
            <th>いびきセンサー</th>
            <td>
              <select v-model="searchConditions.snoreSensor">
                <option></option>
                <option value="1">無</option>
                <option value="2">有</option>
              </select>
            </td>
            <th>HST同梱の有無</th>
            <td>
              <select v-model="searchConditions.hstRequestFlag">
                <option value="[]"></option>
                <option value="1">有</option>
                <option value="2">無</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" v-model="searchConditions.applicationDateEnd"/></td>
            <th>完了日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.completionDateStart"/> ～ <input type="date" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="data.length > 0">
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('totalInspectionsSummaryTable')">クリップボードにコピー</b-button>
          <span class="result-count" style="position: relative; top:6px;">件数：{{data.length}}件</span>
        </div>
        <b-table
          id="totalInspectionsSummaryTable"
          :data="data"
          default-sort="receptionNo"
        >
          <template slot-scope="props">
            <b-table-column field="receptionNo" label="受付番号" width="120" centered sortable>{{props.row.receptionNo}}</b-table-column>
            <b-table-column field="inspectionKind" label="種別" width="180" sortable>{{props.row.inspectionKind}}</b-table-column>
            <b-table-column field="completeDate" label="完了日" width="100" centered sortable>{{props.row.completeDate}}</b-table-column>
            <b-table-column field="blockName" label="ブロック" width="120" sortable>{{props.row.blockName}}</b-table-column>
            <b-table-column field="blockCode" label="ブロックコード" width="100" centered sortable>{{props.row.blockCode}}</b-table-column>
            <b-table-column field="branchOfficeName" label="支店" width="150" centered sortable>{{props.row.branchOfficeName}}</b-table-column>
            <b-table-column field="branchOfficeCode" label="支店コード" width="100" centered sortable>{{props.row.branchOfficeCode}}</b-table-column>
            <b-table-column field="salesOfficeName" label="営業所" width="150" centered sortable>{{props.row.salesOfficeName}}</b-table-column>
            <b-table-column field="salesOfficeCode" label="営業所コード" width="100" centered sortable>{{props.row.salesOfficeCode}}</b-table-column>
            <b-table-column field="medicalInstitutionName" label="医療機関/企業名" width="200" sortable>{{props.row.medicalInstitutionName}}</b-table-column>
            <b-table-column field="medicalInstitutionCode" label="医療機関コード" width="100" centered sortable>{{props.row.medicalInstitutionCode}}</b-table-column>
            <b-table-column field="client" label="依頼元" width="200" sortable>{{props.row.client}}</b-table-column>
            <b-table-column field="clientCode" label="依頼元コード" width="100" centered sortable>{{props.row.clientCode}}</b-table-column>
            <b-table-column field="salesStaff" label="営業担当" width="200" sortable>{{props.row.salesStaff}}</b-table-column>
            <b-table-column field="salesStaffCode" label="営業コード" width="100" centered sortable>{{props.row.salesStaffCode}}</b-table-column>
            <b-table-column field="patientName" label="患者名（漢字）" width="200" sortable>{{props.row.patientName}}</b-table-column>
            <b-table-column field="patientNameKana" label="患者名（カナ）" width="200" sortable>{{props.row.patientNameKana}}</b-table-column>
            <b-table-column field="ahi" label="AHI／RDI／ODI" width="100" centered sortable>{{props.row.ahi}}</b-table-column>
            <b-table-column field="analysisMethod" label="解析方法" width="160" sortable>{{props.row.analysisMethod}}</b-table-column>
            <b-table-column field="snoreSensor" label="いびきセンサー" width="100" sortable>{{props.row.snoreSensor}}</b-table-column>
            <b-table-column v-if="props.row.cvhri!=-1" field="cvhri" label="CVHRI
            (最大値)" width="70" sortable>{{props.row.cvhri}}</b-table-column>
            <b-table-column v-if="props.row.cvhri==-1" field="cvhri" label="CVHRI
            (最大値)" width="70" sortable>算出不可</b-table-column>
            <b-table-column v-if="props.row.afFlag==true" field="afFlag" label="AF" width="160" sortable>有</b-table-column>
            <b-table-column v-if="props.row.afFlag==false" field="afFlag" label="AF" width="160" sortable>無</b-table-column>
            <b-table-column field="hstRequestFlag" label="HST同梱の有無" width="160" sortable>{{props.row.hstRequestFlag}}</b-table-column>
          </template>
        </b-table>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <div class="result-area" v-if="dataBlank && data.length == 0">
        <div class="result-count">件数：{{data.length}}件</div>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType, hstModelValue} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

var header = [
'受付番号',
'種別',
'完了日',
'ブロック',
'ブロックコード',
'支店',
'支店コード',
'営業所',
'営業所コード',
'医療機関/企業名',
'医療機関コード',
'依頼元',
'依頼元コード',
'営業担当',
'営業コード',
'患者名（漢字）',
'患者名（カナ）',
'AHI／RDI／ODI',
'解析方法',
'いびきセンサー',
'CVHRI(最大値)',
'AF',
'HST同梱の有無'
].join('\t')
export default {
  name: "TotalInspectionsSummary",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalSpreadsheet.getSpreadsheetInspectionAnalysisSummaryPOST({
            body: _this.searchConditions
          });
        },
        function(result){
          _this.data = result.obj
          for(var item of _this.data){
            if (item.hstRequestFlag == '1'){
              item.hstRequestFlag = "有"
            }else if(item.hstRequestFlag == '2'){
              item.hstRequestFlag = "無"
            }else{
              item.hstRequestFlag = ""
            }
            // いびきセンサー
            if (item.modelId == hstModelValue.WP300) {
              if (item.snoreSensor){
                item.snoreSensor = "有"
              }else if(!item.snoreSensor){
                item.snoreSensor = "無"
              }
            }else{
              item.snoreSensor = "-"
            }
          }
          _this.dataBlank = true;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      navigator.clipboard
        .writeText(header + '\r\n' + tbody.innerText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    getKenshinKindName: function(kind) {
      var result = kind.label1
      if (result.indexOf('ウォッチパット') >= 0) {
        result = '企業検診（ウォッチパット）'
      }
      return result
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  data() {
    var analysisMethodList = this.getChoiceList(choicesType.psgMethod, false);
    analysisMethodList.unshift({value: ""})
    var holterAnalysisMethodList = this.getChoiceList(choicesType.holterMethod, false);
    let kenshinKindList = this.getChoiceList(choicesType.kenshinKind, true);
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    return {
      data: [],
      searchConditions: {
        receiptNumber: "",
        kind: "",
        analysisMethod: "",
        applicationDateStart: "",
        applicationDateEnd: "",
        completionDateStart: "",
        completionDateEnd: "",
        client:"",
        hospital:"",
        branchOfficeCode:"",
        block:"",
        salesStaff:"",
        salesStaffCode:"",
        dataBlank: false,
        snoreSensor:"",
        },
      analysisMethodList: analysisMethodList,
      holterAnalysisMethodList: holterAnalysisMethodList,
      kenshinKindList: kenshinKindList,
      branchOfficeMaster,
      blockMaster,
      atLaunchHidden: atLaunchHidden
    };
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
input {
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/TotalInspectionsSummary.vue